(function () {
  /**
   * @ngdoc service/provider
   * @name jilResellerMembers
   * @description defines service to manage jil reseller members resources
   */
  angular.module('app.core.api.jil').provider('jilResellerMembers', provider);

  let url;

  /* @ngInject */
  function provider() {
    this.configure = configure;
    this.$get = $get;

    ////////////

    function configure(config) {
      url = `${config.url}/v2/resellers`;
    }

    /* @ngInject */
    function $get($resource) {
      const service = {
        resellerMemberInvitations: getResellerMemberInvitationsResource(),
        resellerMembers: getResellerMembersResource(),
      };

      return service;

      ///////////

      function getResellerMembersResource() {
        return $resource(`${url}/:resellerId/members/:memberId`, {
          memberId: '@memberId',
          resellerId: '@resellerId',
        });
      }

      function getResellerMemberInvitationsResource() {
        return $resource(`${url}/:resellerId/members/invite/:invitationCode`, {
          invitationCode: '@invitationCode',
          resellerId: '@resellerId',
        });
      }
    }
  }
})();
